import { Button, Sheet } from '@astral/ui';
import { useT } from '../providers/I18nProvider.js';

export interface ConfirmSheetProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** A bottom-sheet confirmation dialog. */
export function ConfirmSheet({
  open,
  title,
  message,
  confirmLabel,
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmSheetProps): JSX.Element {
  const t = useT();
  return (
    <Sheet
      open={open}
      onClose={onCancel}
      title={title}
      footer={
        <div className="stack">
          <Button
            fullWidth
            size="lg"
            variant={danger ? 'danger' : 'primary'}
            loading={loading}
            onClick={onConfirm}
          >
            {confirmLabel ?? t('common.confirm')}
          </Button>
          <Button fullWidth size="lg" variant="ghost" onClick={onCancel} disabled={loading}>
            {t('common.cancel')}
          </Button>
        </div>
      }
    >
      <p className="muted">{message}</p>
    </Sheet>
  );
}
